import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { ROUTES } from '../.././sidebar/sidebar.component';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';

// interface
import { Company } from '../../interfaces/company';

// services
import { AuthService } from 'app/services/auth.service';
import { SharedDataService } from '../../services/shared-data.service';
import { InvoiceService } from 'app/services/invoice.service';
import { OrderService } from 'app/services/order.service';
import { SimulationService } from 'app/services/simulation.service';
import { CompanyService } from 'app/services/company.service'
import { AnalyticsService } from '../../services/analytics.service'


const misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
}
declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'navbar-cmp',
    templateUrl: 'navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit {
    private listTitles: any[];
    location: Location;
    private nativeElement: Node;
    private toggleButton;
    private sidebarVisible: boolean;
    private _router: Subscription;
    public open = true;

    public bindCompany: string;
    public Companys: Company[]
    public firstCompany = new Subject<Company>()
    @ViewChild('navbar-cmp', {static: false}) button;

    notificationCout = {nCount: 0}
    pendencyList = []

    constructor(
        location: Location,
        private renderer: Renderer2,
        private element: ElementRef,
        private router: Router,
        private authService: AuthService,
        private sharedData: SharedDataService,
        private invoiceService: InvoiceService,
        private orderService: OrderService,
        private simulatioNService: SimulationService,
        private companyService: CompanyService,
        private analytics: AnalyticsService
        ) {
            this.location = location;
            this.nativeElement = element.nativeElement;
            this.sidebarVisible = false;
        }

        ngOnInit() {
            const urlParams = this.getUrlSegments()[0].path.match(/.{1,2}/g);
            
            if(urlParams.length === 2) {
                this.setInitialData(urlParams)
            } else if (urlParams.length === 3) {
                const params = [urlParams[0], urlParams[1] + urlParams[2]]
                this.setInitialData(params)
            }

            this.companyService.fetchCompany().pipe(first()).subscribe(
                companys => {
                    this.Companys = companys.map(company => {
                        company['tenantId'] = company.companyId + company.branchId;
                        return company
                    })
                    
                    const current = this.Companys.filter(c => c.tenantId === urlParams[0] + urlParams[1] + urlParams[2])

                    if (current.length === 0) {
                        let url = this.router.url.split('/')
                        url = [this.Companys[0].tenantId, 'dashboard']
                        this.router.navigate(url)
                    }
                    const firstCompany = current.length === 0 ? this.Companys[0] : current[0]
                    this.setInitialData([firstCompany.companyId, firstCompany.branchId])
                    this.companyService.companySelected(firstCompany)
                    this.companyService.setCompanySubject(firstCompany)
                }
            )
            this.listTitles = ROUTES.filter(listTitle => listTitle);
            const navbar: HTMLElement = this.element.nativeElement;
            const body = document.getElementsByTagName('body')[0];
            this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
            if (body.classList.contains('sidebar-mini')) {
                misc.sidebar_mini_active = true;
            }
            this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
                const $layer = document.getElementsByClassName('close-layer')[0];
                if ($layer) {
                    $layer.remove();
                }
            });
            this.getNotifications();
        }

        onOptionChange(event) {
            const value = event.target.value;
            let currentEnterprise
            this.Companys.map(enterprise => {
                if (enterprise.companyName === value) {
                    this.companyService.companySelected(enterprise)
                    currentEnterprise = enterprise;
                    this.bindCompany = enterprise.companyId + enterprise.branchId;
                    const attributes = { tenantId: this.bindCompany.toString(), companyName: enterprise.companyName, automaticallySetted: 'false' }
                    this.analytics.recordCustomEventWithAttributes('SelectCompany', attributes);
                }
            })
            this.setSharedData(currentEnterprise)
            this.companyService.setCompanySubject(currentEnterprise)
            this.handleNavigation(currentEnterprise)
            this.returnFromDetail();
        }

        logout() {
            setTimeout(() => {
                this.authService.logout()
            }, 500);
        }

        returnFromDetail() {
            const segments = this.getUrlSegments()
            if (segments[segments.length - 1].path.match(/\d+/) || segments[segments.length - 1].path.match('new') ) {
                const ref = segments[1].path === 'simulation' ? 'simulations' : segments[1].path;
                this.router.navigate([segments[0].path, ref, 'list'])
            }
        }

        minimizeSidebar() {
            const body = document.getElementsByTagName('body')[0];
            if (misc.sidebar_mini_active === true) {
                body.classList.remove('sidebar-mini');
                misc.sidebar_mini_active = false;
                this.open = true;
            } else {
                body.classList.add('sidebar-mini');
                misc.sidebar_mini_active = true;
                this.open = false;
            }
            this.sharedData.isSidebarClosed(!this.open)

            // we simulate the window Resize so the charts will get updated in realtime.
            const simulateWindowResize = setInterval(function() {
                window.dispatchEvent(new Event('resize'));
            }, 180);

            // we stop the simulation of Window Resize after the animations are completed
            setTimeout(function() {
                clearInterval(simulateWindowResize);
            }, 1000);
        }

        isMobileMenu() {
            if (window.outerWidth < 991) {
                return false;
            }
            return true;
        }

        sidebarOpen() {
            const toggleButton = this.toggleButton;
            const html = document.getElementsByTagName('html')[0];
            setTimeout(function() {
                toggleButton.classList.add('toggled');
            }, 500);
            const mainPanel =  <HTMLElement>document.getElementsByClassName('main-panel')[0];
            if (window.innerWidth < 991) {
                mainPanel.style.position = 'fixed';
            }
            html.classList.add('nav-open');
            this.sidebarVisible = true;
        }

        sidebarClose() {
            const html = document.getElementsByTagName('html')[0];
            this.toggleButton.classList.remove('toggled');
            this.sidebarVisible = false;
            html.classList.remove('nav-open');
            const mainPanel =  <HTMLElement>document.getElementsByClassName('main-panel')[0];

            if (window.innerWidth < 991) {
                setTimeout(function() {
                    mainPanel.style.position = '';
                }, 500);
            }
        }

        sidebarToggle() {
            // var toggleButton = this.toggleButton;
            // var body = document.getElementsByTagName('body')[0];
            if (this.sidebarVisible === false) {
                this.sidebarOpen();
            } else {
                this.sidebarClose();
            }
        }

        getTitle() {
            let titlee = this.location.prepareExternalUrl(this.location.path());
            const url = this.getUrlSegments()
            if (titlee.match(/negotiation\/\d+\/simulation/g) !== null) {
                return `Negociações > ${url[2].path} > Simulações`;
            } else if (titlee.match(/simulations|simulation/)) {
                if (titlee.match('simulations/list')) {
                    return 'Simulações'
                } else if (titlee.match(/simulations\/\d+/g) !== null) {
                    if ( $('#save-button').prop('disabled')) {
                        return `Simulações >  ${url[2].path} > Visualização`;
                    }
                    return `Simulações >  ${url[2].path} > Editar`;
                } else if (titlee.match('simulation/new')) {
                    return 'Simulações > Nova Simulação';
                }
                return 'Simulações > Aprovar/Reprovar'
            } else if (titlee.match(/\/negotiation-trade\//)) {
                if (titlee.match('negotiation-trade/list')) {
                    return 'Negociações Trade'
                } else if (titlee.match(/negotiation-trade\/\d+/g) !== null) {
                    if ( $('#save-button').prop('disabled')) {
                        return `Negociações Trade >  ${url[2].path} > Visualização`;
                    }
                    return `Negociações Trade >  ${url[2].path} > Editar`;
                } else if (titlee.match('negotiation-trade/new')) {
                    return 'Negociações Trade > Nova Negociação';
                }
            } else if (titlee.match(/\/negotiation\//)) {
                if (titlee.match('negotiation/list')) {
                    return 'Negociações'
                } else if (titlee.match(/negotiation\/\d+/g) !== null) {
                    return `Negociações > Nova Negociação > ${url[2].path} > Selecionar Simulações`;
                } else if (titlee.match('negotiation/new')) {
                    return 'Negociações > Nova Negociação';
                }
            } else if (titlee.match(/\/order\//)) {
                if (titlee.match('order/list')) {
                    return 'Pedidos'
                } else {
                    return `Pedidos > ${url[2].path} > Visualização`
                }
            } else if (titlee.match(/\/invoice\//)) {
                if (titlee.match('/invoice/list')) {
                    return 'Notas Fiscais'
                } else {
                    return `Notas Fiscais > ${url[3].path}`
                }
            } else if (titlee.match(/\/pre-invoice\//)) {
                if (titlee.match('/pre-invoice/list')) {
                    return 'Notas de Comissão'
                } else if (titlee.match('/pre-invoice/new')) {
                    return `Notas de Comissão > Nova Nota`
                } else {
                     return `Notas de Comissão > ${url[3].path}`
                }
            } else if (titlee.match(/\/purchase-order\//)) {
                if (titlee.match('/purchase-order/list')) {
                    return 'Pedidos de Compra'
                } else {
                    return `Pedidos de Compra > ${url[2].path}`
                }
            } else if (titlee.match(/\/customer\//)) {
                if (titlee.match('customer/list')) {
                    return 'Clientes'
                } else if (titlee.match(/customer\/\d+/g) !== null) {
                    return `Clientes >  ${url[2].path} > Editar`;
                } else if (titlee.match('customer/new')) {
                    return 'Clientes > Novo Cliente';
                }
            } else if (titlee.charAt(0) === '#') {
                titlee = titlee.slice(4)
            }
            for (let item = 0; item < this.listTitles.length; item++) {
                const parent = this.listTitles[item];
                if (parent.path === titlee) {
                    return parent.title;
                } else if (parent.children) {
                    const children_from_url = titlee.split('/')[2];
                    for (let current = 0; current < parent.children.length; current++) {
                        if (parent.children[current].path === children_from_url ) {
                            return parent.children[current].title;
                        }
                    }
                }
            }

            return 'Dashboard';
        }

        setSharedData(company: Company): void {
            const tenantId = `${company.companyId},${company.branchId}`
            this.sharedData.setCurrentEnterprise(company)
            this.sharedData.setTenantId(tenantId)
            this.sharedData.setCompanyId(company.companyId)
            this.sharedData.setBranchId(company.branchId)
            this.sharedData.setUrlReference(company.companyId, company.branchId)
        }

        handleNavigation(company: Company): void {
            const segments = this.getUrlSegments()
            const reference = company.companyId + company.branchId;
            if (segments.length > 2) {
                this.router.navigate([reference, segments[1].path, segments[2].path])
            } else {
                this.router.navigate([reference, segments[1].path])
            }
        }

        getUrlSegments() {
            const tree = this.router.parseUrl(this.router.url);
            const childrens = tree.root.children[PRIMARY_OUTLET];
            return childrens.segments;
        }

        getPath(): string {
            return this.location.prepareExternalUrl(this.location.path());
        }

        setInitialData(urlParams) {
            console.log("urlParams: ", urlParams);
            this.bindCompany = urlParams[0] + urlParams[1];
            this.sharedData.setTenantId(urlParams[0] + ',' + urlParams[1]);
            this.sharedData.setCompanyId(urlParams[0]);
            this.sharedData.setBranchId(urlParams[1]);
            this.sharedData.setUrlReference(urlParams[0], urlParams[1])
        }

        getNotifications() {
            const tokenId = this.sharedData.getTokenId()
            this.companyService.getNotificationCount(tokenId).subscribe(data => {
                this.notificationCout = data
            })

            this.companyService.getPendencyList(tokenId).subscribe(data => {
                this.pendencyList = data
            })
        }

        onClickNotification (event) {
            console.log("event", event)
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
            this.router.navigate([event]))
        }
}
